/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useState } from "react";

import { useSimpleEvent } from "../../../../ui/hooks/useSimpleEvent";
import { ACTION_EDITOR_VIEW_MODE, ActionEditorView } from "../ActionEditorView";
import { ActionEditorDebug } from "./ActionEditorDebug";
import { ActionEditorFlow } from "./ActionEditorFlow";

/**
 * Component props
 */
export interface IActionEditorMainContentProps {
	view: ActionEditorView;
}

/**
 * Main Content Component
 *
 * @param props Component props
 */
export const ActionEditorMainContent: React.FunctionComponent<IActionEditorMainContentProps> = ({ view }) => {
	const [ editorMode, setEditorMode ] = useState(() => view.getMode());

	useSimpleEvent(view.onModeChange, () => setEditorMode(view.getMode()), [ view ], true);

	switch (editorMode) {
		case ACTION_EDITOR_VIEW_MODE.DESIGN:
			return <ActionEditorFlow view={view} />;
		case ACTION_EDITOR_VIEW_MODE.DEBUG:
			return <ActionEditorDebug view={view} />;
	}
};
